<template>
  <v-dialog
    v-if="explorerVisible"
    max-width="700"
    scrollable
    v-model="explorerVisible"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    transition="dialog-fade-transition"
  >
    <v-card>
      <v-card-title class="avoid-title-stretch-on-fullscreen-dialog">
        <span class="headline mb-0">Legg til innhold</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-tabs slider-color="primary" v-model="activeTab">
        <v-tab v-for="tab in tabs" :key="tab" ripple>
          {{ tab }}
        </v-tab>
        <v-tab-item>
          <profiles-list
            selected-category="Alle"
            @profile-added="closeDialog"
            :use-in-dialog="true"
            :show-download-action="false"
            :open-map-on-click="true"
          />
        </v-tab-item>
        <v-tab-item>
          <v-text-field
            class="pt-3 pl-3 pr-3"
            label="Gi tegnelaget et navn (obligatorisk)"
            v-model="layerTitle"
            box
            full-width
            maxlength="100"
          ></v-text-field>
          <v-textarea
            class="pl-3 pr-3 pb-0"
            label="Beskrivelse (valgfritt)"
            v-model="layerDescription"
            maxlength="500"
            box
          ></v-textarea>
        </v-tab-item>

        <v-tab-item>
          <div class="pa-4">
            <v-layout v-if="shapeImportLoading" align-center column fill-height>
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-layout>
            <v-layout
              v-if="!shapeImportLoading"
              align-center
              column
              fill-height
            >
              <p v-if="shapeInputFormData == null">
                Her kan du legge til en fil fra datamaskinen i kartet. Følgende
                filtyper er støttet
                <strong>shapefiler i .zip format</strong>,
                <strong>.geojson</strong>, og <strong>.gpx</strong>. Når filen
                er lastet opp vil den bli lagt til som et kartlag. Merk: Noen
                aspekter rundt kml er ikke støttet. Hvis man importerer
                shapefiler som inneholder kompleks geometri vil geometrien i
                noen tilfeller generaliseres (dvs. knekkpunkter vil bli fjernet
                automatisk for å forenkle geometrien).
              </p>

              <v-btn
                v-if="shapeInputFormData == null"
                color="primary"
                flat
                @click="$refs.inputUpload.click()"
                >Velg fil (åpne utforsker)</v-btn
              >
              <form
                enctype="multipart/form-data"
                method="post"
                ref="uploadForm"
                id="uploadForm"
              >
                <input
                  v-show="false"
                  ref="inputUpload"
                  name="file"
                  id="inFile"
                  type="file"
                  @change="createLayerFromFile"
                />
              </form>
            </v-layout>

            <v-text-field
              v-if="shapeInputFormData && !shapeImportLoading"
              label="Angi et navn for kartlaget"
              v-model="shapeLayerTitle"
              box
              maxlength="50"
            ></v-text-field>
            <v-checkbox
              v-if="shapeInputFormData && !shapeImportLoading"
              v-model="zoomToShapeLayer"
              color="primary"
              label="Zoom til kartlaget etter opprettelse"
            ></v-checkbox>
          </div>
        </v-tab-item>
      </v-tabs>

      <v-card-actions
        color="grey"
        class="avoid-title-stretch-on-fullscreen-dialog"
      >
        <v-btn
          class="mr-3"
          v-if="
            activeTab === addShapeFileTabIndex &&
              shapeInputFormData !== null &&
              !shapeImportLoading
          "
          color="primary"
          flat
          @click="resetShapeFileTab"
        >
          Tilbake
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="activeTab === addMapLayerTabIndex"
          color="primary"
          flat
          @click="closeDialog"
        >
          Tilbake til kartet
        </v-btn>
        <v-btn
          class="mr-3"
          v-if="
            activeTab === addShapeFileTabIndex &&
              shapeInputFormData !== null &&
              !shapeImportLoading
          "
          :disabled="!shapeLayerTitle"
          color="primary"
          flat
          @click="initiateShapeImport"
        >
          Fullfør
        </v-btn>
        <v-btn
          class="mr-3 mb-3"
          flat
          v-if="activeTab === addDrawingLayerTabIndex"
          color="primary"
          :disabled="!layerTitle"
          @click="addDrawingLayer"
          >Opprett tegnelag</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import MappingMixin from "@/mixins/mappingMixin";
import ImportMixin from "@/mixins/importMixin";
export default {
  name: "LayerAddDialog",
  components: {
    ProfilesList: () => import("@/components/ProfilesList")
  },
  mixins: [MappingMixin, ImportMixin],
  computed: {
    ...mapState([
      "profiles",
      "mapLoaded",
      "mapProfiles",
      "sidebarHasOpened",
      "favourites"
    ]),
    explorerVisible: {
      set(explorerVisible) {
        this.setExplorerVisible(explorerVisible);
      },
      get() {
        return this.$store.state.explorerVisible;
      }
    }
  },
  data: () => ({
    dialog: false,
    searchValue: "",
    drawer: false,
    myDrawingLayers: [],
    tabsItemActive: null,
    tabs: ["Kartlag", "Tegnelag", "Fil fra datamaskin"],
    layerTitle: "",
    shapeLayerTitle: "",
    layerDescription: "",
    activeTab: 0,
    addMapLayerTabIndex: 0,
    addDrawingLayerTabIndex: 1,
    addShapeFileTabIndex: 2,
    shapeInputFormData: null,
    shapeImportLoading: false,
    fileFormat: null,
    zoomToShapeLayer: true
  }),
  watch: {
    explorerVisible(val) {
      if (val) {
        this.myDrawingLayers = JSON.parse(localStorage.getItem("localLayers"));
      }
    }
  },
  methods: {
    ...mapActions([
      "setSnack",
      "setSelectedMapProfile",
      "addGraphicsLayer",
      "activateTool",
      "setExplorerVisible"
    ]),
    ...mapActions(["hideExplorer"]),
    updateLayerList() {},
    resetShapeFileTab() {
      this.shapeInputFormData = null;
      this.shapeLayerTitle = "";
      this.fileFormat = "";
      this.$refs.inputUpload.value = null;
    },
    createLayerFromFile(evt) {
      let fileName = evt.target.value.toLowerCase();

      let name = fileName.split(".");
      this.shapeLayerTitle = name[0].replace("c:\\fakepath\\", "");
      this.fileFormat = name[1] === "zip" ? "shapefile" : name[1];
      if (this.fileFormat === "gpx" || this.fileFormat === "kml") {
        this.shapeInputFormData = this.$refs.inputUpload.files[0];
      } else {
        this.shapeInputFormData = this.$refs.uploadForm;
      }
    },
    initiateShapeImport() {
      this.shapeImportLoading = true;
      this.importFeaturesFromGISFileAndAddAsLayer({
        name: this.shapeLayerTitle,
        format: this.fileFormat,
        formData: this.shapeInputFormData
      })
        .then(result => {
          this.shapeImportLoading = false;
          if (this.zoomToShapeLayer) {
            this.zoomTo(result.graphics);
          }
          this.closeDialog();
        })
        .catch(error => {
          console.error(error);
          this.shapeImportLoading = false;
        });
    },
    addDrawingLayer() {
      let id = new Date().getTime().toString();

      let drawingLayerProfile = {
        id: id,
        showInfoMenu: false,
        appTitle: this.layerTitle,
        Temaforklaring: this.layerDescription
      };

      this.addMapProfile(drawingLayerProfile).then(() => {
        let addedProfile = this.$store.getters["getAddedMapProfile"](id);
        this.setSelectedMapProfile(addedProfile);
        this.activateTool("drawing");
        this.closeDialog();
      });
    },
    getImgUrl(id) {
      try {
        return require("../../../../assets/small/" + id + ".jpg");
      } catch (e) {
        require("../../../../assets/small/" + "placeholder" + ".jpg");
      }
    },
    closeDialog: function() {
      this.explorerVisible = false;
      this.searchValue = "";
      this.layerTitle = "";
      this.layerDescription = "";
      this.shapeLayerTitle = "";
      this.activeTab = 0;
      this.shapeInputFormData = null;
      this.shapeImportLoading = false;
      if (typeof this.$refs.inputUpload !== "undefined") {
        this.$refs.inputUpload.value = null;
      }
    },
    selectProfile: function(name, item) {
      if (item && this.mapLoaded) {
        if (item.hasOwnProperty("graphics")) {
          this.addMapProfile(item);
        } else {
          this.addMapProfile({
            id: name,
            type: item.type,

            showInfoMenu: false
          });
        }
      }
    }
  },
  mounted() {
    this.myDrawingLayers = JSON.parse(localStorage.getItem("localLayers"));
  }
};
</script>

<style scoped>
.bottom-gradient {
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.9) 0%,
    transparent 85px
  );
}

.image-gradient {
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, transparent);
}

.avoid-title-stretch-on-fullscreen-dialog {
  flex: 0 !important;
}
</style>
